<template>
  <div class="step-header" v-if="current">
    <div class="step-eyebrow">שלב {{ idx + 1 }} מתוך {{ total }}</div>
    <h1 class="step-title">{{ current.title }}</h1>
    <p class="step-sub">{{ current.sub }}</p>
  </div>
</template>

<script>
import { STEPS } from './data.js';

export default {
  name: 'StepHeader',
  props: {
    idx:   { type: Number, required: true },
    total: { type: Number, required: true },
  },
  computed: {
    current() { return STEPS[this.idx]; },
  },
}
</script>
